import {
  AI_OPS,
  AUTONOMOUS_DEM,
  AUTONOMOUS_DEM_MOBILE,
  AUTONOMOUS_DEM_REMOTE,
  CASB,
  CIE,
  CUSTOMER_SUCCESS,
  DATA_TRANSFER,
  DLP,
  DVR,
  IOT,
  LOGGING_SERVICE,
  NET_INTER_CONNECT,
  OKYO,
  PAN_CHINA,
  FEDRAMP,
  PANOROMA,
  PRISMA_ACCESS,
  PRISMA_ACCESS_EDITION,
  PRISMA_ACCESS_MOBILE,
  PRISMA_ACCESS_REMOTE,
  PRISMA_SAAS_DISPLAY_NAME,
  PRISMA_SDWAN,
  PRIVATE_APPS,
  PRIVATE_APPS_QTY,
  SERVICE_CONNECTION,
  SERVICE_LOCATION,
  SUPPORT, APP_ACCELERATION,
} from '../../../common/constants/LabelConstants'

export const CREATE_NEW = 'Create New'

export const KEYS = {
  'TSG': 'default-tsg-component',
  'CSP': 'default-csp-component',
  'REGION': 'default-region-component',
  'CDL': 'default-cdlQuantity-component'
}

export const TSG_FIELD_NAME = 'tsg'
export const REGION_FIELD_NAME = 'region'
export const CSP_FIELD_NAME = 'csp'
export const DEFAULT_TENANT_NAME = 'Tenant Name'


export const APP_ID_LOGGING_SERVICE = 'logging_service'
export const APP_ID_PRISMA_ACCESS = 'prisma_access'
export const APP_ID_DSS_ID = 'directory_sync'
export const APP_ID_PRISMA_SAAS = 'aperture'
export const APP_ID_PRISMA_ACCESS_PANORAMA = 'prisma_access_panorama'
export const APP_ID_PRISMA_ACCESS_EDITION = 'prisma_access_edition'
export const APP_ID_PRISMA_ACCESS_EDITION_ONPREM = `${APP_ID_PRISMA_ACCESS_EDITION}_onprem`
export const APP_ID_PRISMA_ACCESS_MOBILE_USERS = 'prisma_access_for_mobile_users'
export const APP_ID_PRISMA_ACCESS_REMOTE_NETWORKS = 'prisma_access_for_remote_networks'
export const APP_ID_PRISMA_ACCESS_FOR_CLEAN_PIPE = 'prisma_access_for_clean_pipe'
export const APP_ID_AUTONOMOUS_DEM = 'adem'
export const APP_ID_AUTONOMOUS_DEM_MOBILE = 'adem_for_mobile'
export const APP_ID_AUTONOMOUS_DEM_REMOTE_NETWORKS = 'adem_for_remote_networks'
export const APP_ID_NET_INTER_CONNECT = 'net_interconnect'
export const APP_ID_PRIVATE_APPS = 'private_app_access'
export const APP_ID_PRIVATE_APPS_QTY = 'private_app_access_qty'
export const APP_ID_DATA_TRANSFER = 'data_transfer'
export const APP_ID_DLP = 'dlp'
export const APP_ID_IOT = 'zingbox'
export const APP_ID_CUSTOMER_SUCCESS = 'customer_success'
export const APP_ID_PRISMA_ACCESS_ONPERM = 'prisma_access_edition_onprem'
export const APP_ID_SERVICE_CONNECTION = 'service_connection'
export const APP_ID_SDWAN = 'cgx'
export const APP_ID_DVR = 'dvr'
export const APP_ID_PANORAMA = 'panorama'
export const APP_ID_OKYO = 'OKYO'
export const APP_ID_SUPPORT = 'support'
export const APP_ID_CASB = 'CASB'
export const APP_ID_CASB_NGFW = 'CASB_NGFW'
export const CTX_CDL = 'cdl'
export const APP_ID_SERVICE_LOC = 'add_loc'
export const APP_ID_CIE = APP_ID_DSS_ID
export const APP_ID_PAN_CHINA = 'pan_china'
export const APP_ID_AI_OPS = 'add_aiops'
export const APP_ID_NG_CASB = 'ng_casb'
export const APP_ID_FEDRAMP = 'fedramp'
export const NGFW = 'ngfw'
export const APP_ID_ADEM_AIOPS = 'add_adem_aiops'
export const APP_ID_BACKBONE = 'mssp_backbone'
export const APP_ID_APP_ACCELERATION = 'add_app_accl'
export const APP_ID_CORTEX_XDR = 'cortex_xdr'
export const APP_ID_AUTO_CORTEX_XDR = 'auto_cortex_xdr'


export const MULTIPLE_APPID = [APP_ID_PRISMA_ACCESS_EDITION, APP_ID_AUTONOMOUS_DEM, APP_ID_PRISMA_ACCESS_ONPERM]

export const APP_ID_TO_UNIT: { [index: string]: string } = {
  [APP_ID_LOGGING_SERVICE]: 'TB',
  [APP_ID_PRISMA_ACCESS_MOBILE_USERS]: 'Users',
  [APP_ID_PRISMA_ACCESS_REMOTE_NETWORKS]: 'Mbps',
  [APP_ID_NG_CASB]: 'Users'
}
export const APP_TO_ALIAS: { [index: string]: string } = {
  [APP_ID_LOGGING_SERVICE]: 'Data Space'
}
//TODO: REMOVE THIS, DON'T USE THIS, USE APP REGISTRY
export const APP_ID_TO_NAME: {[index: string]: string} = {
  [APP_ID_LOGGING_SERVICE]: LOGGING_SERVICE,
  [APP_ID_PRISMA_ACCESS]: PRISMA_ACCESS,
  [APP_ID_DSS_ID]: CIE,
  [APP_ID_PRISMA_SAAS]: PRISMA_SAAS_DISPLAY_NAME,
  [APP_ID_PRISMA_ACCESS_EDITION]: PRISMA_ACCESS_EDITION,
  [APP_ID_NET_INTER_CONNECT]: NET_INTER_CONNECT,
  [APP_ID_PRIVATE_APPS]: PRIVATE_APPS,
  [APP_ID_PRIVATE_APPS_QTY]: PRIVATE_APPS_QTY,
  [APP_ID_DATA_TRANSFER]: DATA_TRANSFER,
  [APP_ID_DLP]: DLP,
  [APP_ID_AUTONOMOUS_DEM]: AUTONOMOUS_DEM,
  [APP_ID_AUTONOMOUS_DEM_MOBILE]: AUTONOMOUS_DEM_MOBILE,
  [APP_ID_AUTONOMOUS_DEM_REMOTE_NETWORKS]: AUTONOMOUS_DEM_REMOTE,
  [APP_ID_IOT]: IOT,
  [APP_ID_CUSTOMER_SUCCESS]: CUSTOMER_SUCCESS,
  [APP_ID_PRISMA_ACCESS_ONPERM]: PRISMA_ACCESS,
  [APP_ID_PRISMA_ACCESS_PANORAMA]: PRISMA_ACCESS,
  [APP_ID_PRISMA_ACCESS_MOBILE_USERS]: PRISMA_ACCESS_MOBILE,
  [APP_ID_SERVICE_CONNECTION]: SERVICE_CONNECTION,
  [APP_ID_SDWAN]: PRISMA_SDWAN,
  [APP_ID_DVR]: DVR,
  [APP_ID_PRISMA_ACCESS_REMOTE_NETWORKS]: PRISMA_ACCESS_REMOTE,
  [APP_ID_OKYO]: OKYO,
  [APP_ID_PANORAMA]: PANOROMA,
  [APP_ID_SUPPORT]: SUPPORT,
  [APP_ID_CASB]: CASB,
  [APP_ID_SERVICE_LOC]: SERVICE_LOCATION,
  [APP_ID_AI_OPS]: AI_OPS,
  [APP_ID_PAN_CHINA]: PAN_CHINA,
  [APP_ID_FEDRAMP]: FEDRAMP,
  [APP_ID_ADEM_AIOPS]: AI_OPS,
  [APP_ID_APP_ACCELERATION]: APP_ACCELERATION,
}
export const LABEL_NOT_APPLICABLE = 'Not Applicable'
export const LABEL_NOT_APPLICABLE_SHORT = 'N/A'

export const APP_UNITS: {[index: string]: string} = {
  'Remote Network': 'Mbps',
  'Mobile Users': 'Users'
}
export const DO_NOT_RENDER_UNITS = new Set([APP_ID_DLP, APP_ID_PRISMA_SAAS, APP_ID_PAN_CHINA, APP_ID_FEDRAMP])

export const DO_NOT_RENDER_DUPLICATES = new Set([APP_ID_DLP, APP_ID_PRISMA_SAAS])
export const DONT_RENDER_APP = [APP_ID_PRISMA_ACCESS_EDITION, APP_ID_PRISMA_ACCESS_EDITION_ONPREM]
export const DO_NOT_DISPLAY_ADDONS = new Set([APP_ID_PAN_CHINA, APP_ID_FEDRAMP])

export const LICENSE_STATUS_PROVISIONING = 'provisioning'
export const LICENSE_STATUS_RUNNING = 'running'
export const LICENSE_STATUS_ERROR = 'error'
export const LICENSE_STATUS_EXPIRED = 'expired'
export const LICENSE_STATUS_STOPPED = 'stopped'
export const LICENSE_STATUS_WARNING = 'warning'
export const LICENSE_STATUS_INITIALIZING = 'initializing'
export const LICENSE_STATUS_COMPLETE = 'complete'

export const LICENSE_STATUS_LABEL_PROVISIONING = 'Provisioning'
export const LICENSE_STATUS_LABEL_RUNNING = 'Up'
export const LICENSE_STATUS_LABEL_ERROR = 'Error'
export const LICENSE_STATUS_LABEL_EXPIRED = 'Expired'
export const LICENSE_STATUS_LABEL_STOPPED = 'Stopped'
export const LICENSE_STATUS_LABEL_NOT_PROVISIONED = 'Not Provisioned'
export const LICENSE_STATUS_LABEL_WARNING = 'Warning'
export const LICENSE_STATUS_LABEL_INITIALIZING = 'Initializing'
export const LICENSE_STATUS_LABEL_COMPLETE = 'Complete'

export const LICENSE_STATUS_LABEL_COMPLETE_PERCENT = 100
export const LICENSE_STATUS_LABEL_ERROR_PERCENT = 0
export const LABEL_NONE = 'None'
export const BUTTON_GENERATE_OTP = 'Generate OTP'

export const INSTANCE_TABLE_HEADER = 'Current Services'

export const REMOTE_NETWORK_LABEL = 'Remote Network'
export const MOBILE_USERS_LABEL = 'Mobile Users'

export const VIEW_MANAGE_TENANT = '/tenant_management'

export const ACTIVATION_TYPE = {
  AMEND: 'AMEND',
  NEW: 'NEW'
}

export const GLOBAL_REGIONS_APPS = 'global'
export const DESCRIPTION = 'Description'

export const ALLOCATION_FULL = 'FULL'
export const ALLOCATION_SHARED = 'SHARED'
